import React, { useEffect, useState, useRef } from 'react';
/**
 * MoneyAssemblerRenderer — Wrapper adapting MoneyAssembler to renderer interface.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 */
import { QuestionRendererProps } from './types';
import { MoneyAssembler } from '../MoneyAssembler';
import { useEdgeTriggeredSubmit } from './useEdgeTriggeredSubmit';
export function MoneyAssemblerRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const [answerPayload, setAnswerPayload] = useState('');
  useEdgeTriggeredSubmit(answerPayload, shouldValidate, onAnswer, question.id);
  const handleComplete = (userAnswer: string) => {
    setAnswerPayload(userAnswer);
  };
  return <MoneyAssembler question={question} onComplete={handleComplete} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-10595" />;
}